module.exports = __webpack_public_path__ + "img/refresh.47942727.png";